/**
 * Settings > Notifications, under "Enable desktop notifications": the
 * device's own switches (notify/prefs.ts). The same on the web and in the
 * desktop app; the labels say taskbar or tab.
 */
import { useT } from '../i18n';
import { desktopBridge } from '../lib/config';
import { SetGroup, SetRow } from '../settings/Settings';
import { useSounds } from '../sound/sounds';
import { Switch } from '../ui/kit';
import { notificationSoundsOn, setNotificationSounds, useNotifyPrefs } from './prefs';

export function NotifyDeviceSettings() {
  const { t } = useT();
  const prefs = useNotifyPrefs((s) => s.prefs);
  const setPrefs = useNotifyPrefs((s) => s.setPrefs);
  const sounds = useSounds((s) => notificationSoundsOn(s.prefs));
  const web = !desktopBridge();
  const row = (label: string, sub: string, checked: boolean, set: (v: boolean) => void) => (
    <SetRow label={label} sub={sub}>
      <Switch checked={checked} label={label} onChange={set} />
    </SetRow>
  );
  return (
    <SetGroup>
      {row(t('nt.set.sounds'), t('nt.set.soundsSub'), sounds, setNotificationSounds)}
      {row(t('nt.set.preview'), t('nt.set.previewSub'), prefs.preview, (v) =>
        setPrefs({ preview: v }),
      )}
      {row(
        t(web ? 'nt.set.badgeWeb' : 'nt.set.badge'),
        t(web ? 'nt.set.badgeWebSub' : 'nt.set.badgeSub'),
        prefs.badge,
        (v) => setPrefs({ badge: v }),
      )}
      {row(
        t(web ? 'nt.set.flashWeb' : 'nt.set.flash'),
        t(web ? 'nt.set.flashWebSub' : 'nt.set.flashSub'),
        prefs.flash,
        (v) => setPrefs({ flash: v }),
      )}
    </SetGroup>
  );
}
